<template>
  <div class="locale-switcher dropdown">
    <button class="btn btn-default dropdown-toggle" type="button" id="locale-dropdown" :aria-label="$t('vue.components.locale_switcher.change_language')" v-dropdown>
      <span class="glyphicon glyphicon-globe" aria-hidden="true"></span>
      <span class="hidden-xs">{{ currentLocaleLabel }}</span>
      <span class="caret"></span>
    </button>

    <ul class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="locale-dropdown">
      <li v-for="locale in availableLocales" :key="locale.code" role="presentation">
        <a href="#" role="menuitem" @click.prevent="switchLocale(locale.code)">{{ locale.label }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'locale-switcher',

  props: {
    currentLocale: { type: String, required: true }
  },

  data() {
    return {
      localeLabels: {
        de: 'Deutsch',
        en: 'English',
        fr: 'Français'
      }
    }
  },

  computed: {
    currentLocaleLabel() {
      return this.localeLabels[this.currentLocale]
    },

    availableLocales() {
      return ['de', 'en', 'fr']
        .filter(code => code !== this.currentLocale)
        .map(code => ({ code, label: this.localeLabels[code] }))
    }
  },

  methods: {
    switchLocale(locale) {
      // Set cookie
      const maxAge = 60 * 60 * 24 * 365 * 100
      const secure = window.location.protocol === 'https:' ? '; Secure' : ''
      document.cookie = `_wois_locale=${locale}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`

      // Reload to apply new locale
      window.location.reload()
    }
  }
}
</script>
